/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {CompoApiService} from './compo-api.service';
import {ApiResponse} from '../interfaces/ApiResponse';
import {BaseService} from './base.service';
import {Contract} from '../interfaces/Contract';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ContractService extends BaseService {

  constructor(private readonly apiService: CompoApiService) {
    super();
  }

  getAll(): Observable<ApiResponse<Contract[]>> {
    return this.apiService.get<Contract[]>('/contract').pipe(catchError(err => this.handleError(err)));
  }
}
